import {
  MeetingTypeOverrides,
  MeetingTypeRef,
  TimeInterval,
  AvailabilityFeature,
  StrictRoundRobin1,
  RoundRobinAvailableAttendees,
  FlexibleRoundRobin,
} from '@chilipiper/api-client/src/user-availability'

export type AvailabilitySpan = {
  startsAt: string
  endsAt: string
}

export type BaseRequest = {
  meetingTypeRef: MeetingTypeRef
  meetingTypeOverride: MeetingTypeOverrides
  interval: TimeInterval
  intervalStartsAt: string
  availabilityEndsAt: string
  feature?: AvailabilityFeature
}

export type BuildBaseRequest = {
  intervalDuration: string
  intervalStartsAt: string
  availabilityEndsAt: string
  meetingTypeId: string
  meetingTypeVersion?: string
  meetingDurationOverride?: string
  beforeBufferDurationOverride?: string
  afterBufferDurationOverride?: string
}

export const isStrictRoundRobinAssignees = (
  assignees?: RoundRobinAvailableAttendees[]
): assignees is StrictRoundRobin1[] => {
  return (
    (assignees?.length || 0) > 0 &&
    (assignees?.every(assignee => assignee.type === 'StrictRoundRobin') ?? false)
  )
}

export const hasFlexibleRoundRobinAssignees = (
  assignees?: RoundRobinAvailableAttendees[]
): assignees is FlexibleRoundRobin[] => {
  return assignees?.some(assignee => assignee.type === 'FlexibleRoundRobin') ?? false
}
